import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Divider component
 *
 * @param {object} - props.color - Color.
 * @param {string} - props.height - Height.
 */
export const Divider = ({color, height}) => {
    return (
        <Box className={'divider'}>
            <Box background={color?.value} height={height} />
        </Box>
    )
}

Divider.propTypes = {
    color: PropTypes.object,
    height: PropTypes.string
}

export default Divider
